var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aha-presentation-editor-wrapper"},[_c('SocketError'),(!_vm.isRendering)?_c('LoadingScreen'):_vm._e(),_c('div',{staticClass:"flex flex-1 min-h-0"},[_c('div',{staticClass:"relative flex min-h-0"},[_c('MiddleForSharingView',{staticClass:"aha-middle",on:{"nextSlideHandler":_vm.nextSlideHandler}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }